import React, { useState} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useMutation } from "react-query";
import { setShowGetKuwaitAppBtn ,setShowAuthModal, setShowEnableMediumAuthBtn} from "../../reducer/utilitySlice";
import { callQueryapi } from "../../services/http/callapi";

import {
    getGlobalSettingValue,
    secondsToHms,
  } from '../../services/common/utils';
import { setAuthModalContent, setShouldTimerStart } from "../../reducer/utilitySlice";
import { setCdrCivilID } from "../../reducer/cdrSlice";
import { CDR_AUTH_STATUS, CDR_HAS_MOBILEID } from "../../services/common/endpoints";

const PaciCheck = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [transid, setTransid] = useState('');
    const {cdrData: {civilID}} = useSelector(state => state);

    const {
        utilityData: { globalSetting },
      } = useSelector((state) => state);
    const settingsArr = globalSetting ? globalSetting?.Globalsettings[0]?.items[0]?.metadata : [];
  

    const getMobileIdStatusCheck
    = useQuery(
        [{}, 
          CDR_HAS_MOBILEID, 
        {
            "civilid": civilID,
            iscdr : "t",
            "source": "cdr"
           
        }, {}, false, 'paci'],
        {
          enabled: false,
          retry: false,
          cacheTime: 0,
          staleTime: 0,
          onSuccess: ({ data: resData }) => {
            const time = new Date();
            const expirySeconds = isNaN(
              parseInt(getGlobalSettingValue('mobileidshowtimerlimit', settingsArr))
            )
              ? 300
              : parseInt(
                getGlobalSettingValue('mobileidshowtimerlimit', settingsArr)
                );
            time.setSeconds(time.getSeconds() + expirySeconds);  
           
            if (resData?.status === '0') { 
                dispatch(
                  setAuthModalContent({
                    icon: getGlobalSettingValue(
                      'loginapprovalrequesticon_web',
                      settingsArr
                    ),
                    title:resData?.message,
                    message: resData?.infomsg,
                    btnText: resData?.buttontext,
                  })
                );
                dispatch(setShowAuthModal(true))
              setTransid(resData?.response?.transid);
              dispatch(setShouldTimerStart(true));
              props?.startTimer(time);
            } else {
                
                  if (resData?.data?.verificationlevel?.toLowerCase() === 'low') {
                    dispatch(setShowEnableMediumAuthBtn(true));
                    dispatch(
                      setAuthModalContent({
                        icon: getGlobalSettingValue(
                          'enablemediumauthicon_web',
                          settingsArr
                        ),
                        title: resData?.message,
                        message: resData?.infomsg,
                        btnText: resData?.buttontext,
                      })
                    );
                    dispatch(setShowAuthModal(true))
                  } else {
                    dispatch(setShowGetKuwaitAppBtn(true));
                    dispatch(
                        setAuthModalContent({
                          icon: getGlobalSettingValue(
                            'registermobileidfailureicon_web',
                            settingsArr
                          ),
                          title: resData?.message,
                          message: resData?.infomsg,
                          btnText: resData?.buttontext,
                        })
                      );
                      dispatch(setShowAuthModal(true))
                  }
                
            }
          }
          
        }
      );

      
  const getAuthStatusCheck = useMutation(
    () =>
      callQueryapi({
        queryKey: [
          {},
          CDR_AUTH_STATUS,
          { transid: transid, type: 'KUWAITMOBILEID' },
          {},false, 'paci'
        ],
      }),
    {
      onSuccess: ({ data: resData }) => {
       
        if (resData?.status === '0') {
            // setItemInSessionStorage(IS_2FA_DONE, 'true');  have to verify again and again
            props?.pauseTimer();
            dispatch(setShouldTimerStart(false));
            dispatch(setShowAuthModal(false));
            
            if(props?.successFuncCall){
              props?.successFuncCall();
            }
          
        
        } else {
          if (resData?.code === '83709') {
            dispatch(
              setAuthModalContent({
                icon: getGlobalSettingValue(
                  'approvalrequestagainicon_web',
                  settingsArr
                ),
                title:  resData?.message,
                message: resData?.infomsg,
                btnText: resData?.buttontext,
              })
            );
            dispatch(setShouldTimerStart(false));
            // dispatch(setShouldTimerStart(false));
            // dispatch(setShowAuthModal(false));
            // dispatch(setShowAuthErrorModal(true));
            // dispatch(
            //   setAuthErrorModalContent({
            //     message: t('somethingwentwrong'),
            //   })
            // );
          }
          else if(!props?.isTimerRunning){
            dispatch(
              setAuthModalContent({
                icon: getGlobalSettingValue(
                  'approvalrequestagainicon_web',
                  settingsArr
                ),
                title: getMobileIdStatusCheck?.data?.data?.timeoutpopup?.title,
                message: getMobileIdStatusCheck?.data?.data?.timeoutpopup?.desc,
                btnText: getMobileIdStatusCheck?.data?.data?.timeoutpopup?.buttontext
              })
            );
            dispatch(setShouldTimerStart(false));
          }
        }
      },
    }
  );

    return {
        getMobileIdStatusCheck,
        getAuthStatusCheck
    }
}

export default PaciCheck